Date.prototype.format = function (f) {

    if (!this.valueOf()) return " ";



    var weekKorName = ["일요일", "월요일", "화요일", "수요일", "목요일", "금요일", "토요일"];

    var weekKorShortName = ["일", "월", "화", "수", "목", "금", "토"];

    var weekEngName = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

    var weekEngShortName = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    var d = this;



    return f.replace(/(yyyy|yy|MM|dd|KS|KL|ES|EL|HH|mm|ss|a\/p)/gi, function ($1) {

        switch ($1) {

            case "yyyy": return d.getFullYear(); // 년 (4자리)

            case "yy": return (d.getFullYear() % 1000).zf(2); // 년 (2자리)

            case "MM": return (d.getMonth() + 1).zf(2); // 월 (2자리)

            case "dd": return d.getDate().zf(2); // 일 (2자리)

            case "KS": return weekKorShortName[d.getDay()]; // 요일 (짧은 한글)

            case "KL": return weekKorName[d.getDay()]; // 요일 (긴 한글)

            case "ES": return weekEngShortName[d.getDay()]; // 요일 (짧은 영어)

            case "EL": return weekEngName[d.getDay()]; // 요일 (긴 영어)

            case "HH": return d.getHours().zf(2); // 시간 (24시간 기준, 2자리)

            case "mm": return d.getMinutes().zf(2); // 분 (2자리)

            case "ss": return d.getSeconds().zf(2); // 초 (2자리)

            case "a/p": return d.getHours() < 12 ? "오전" : "오후"; // 오전/오후 구분

            default: return $1;

        }

    });

};



String.prototype.string = function (len) { var s = '', i = 0; while (i++ < len) { s += this; } return s; };

String.prototype.zf = function (len) { return "0".string(len - this.length) + this; };

Number.prototype.zf = function (len) { return this.toString().zf(len); };



// var config = require('./config/config.json')
export const API_DOMAIN = process.env.REACT_APP_API_URL;
export const BRANCH_ID_UANGEL = 85;


export const RESPONSE = {
    'OK': {code: 200, msg: '요청 성공'},
    'NON_IDS': {code: 400, msg: '필요한 정보가 없습니다.'},
    'NON_TOKEN': {code: 403, msg: '토큰 정보가 없습니다.'},

    'INVALID_TOKEN': {code: 2000, msg: '로그인 정보가 만료되었거나 유효하지 않습니다.'},
    'NOT_FOUND_ID': {code: 2001, msg: '아이디를 찾을 수 없습니다.'},
    'INCORRECT_PASSWD': {code: 2002, msg: '비밀번호가 일치하지 않습니다.'},
    'NOT_APPROVAL_USER': {code: 2003, msg: '승인되지 않은 사용자 입니다.'},

    'ALREADY_ITEM': {code: 3000, msg: '이미 등록된 정보입니다.'},
    'NOT_FOUND_ITEM': {code: 3001, msg: '요청하신 정보를 찾을수 없습니다.'},
    'MAX_NUM_EXCEEDED': {code: 3005, msg: '가능한 최대 보관수를 초과하였습니다.'},
    
    'MISSING_PARAM'     : {code: 4000, msg: '요청을 처리할 수 없습니다. 필수 전달 값이 누락되었습니다.'},
    'INVALID_PARAM'     : {code: 4002, msg: '전달 값이 적절하지 않거나 범위를 초과하거나 미달하였습니다.'},
    'INVALID_CHAR_USERID'     : {code: 4003, msg: '아이디는 5자리 이상의 영문/숫자만 이용가능합니다.'},
    'INVALID_STATUS'    : {code: 4100, msg: '처리할수 없는 상태입니다.'},
    'NO_AUTH_MODIFY'    : {code: 4101, msg: '현재 계정으로 처리할 수 없는 요청입니다.'},
    'NO_AUTH_ADMIN'     : {code: 4102, msg: '관리자(본사) 전용 기능입니다.'},
    'NO_AUTH_APP'       : {code: 4103, msg: '해당 앱에서 허용되지 않은 요청입니다.'},

    'TEST_ONLY': {code: 5001, msg: '테스트 버전에서만 사용할 수 있는 기능입니다.'},
    'TOO_MANY_REQ': {code: 5005, msg: '네트워크 연결을 확인해 주세요. 과도한 요청으로인해 연결이 거부되었습니다.'},

    'SERVER_ERROR': {code: 9000, msg: '서버 응답이 없거나 오류가 발생하였습니다.'},
    'DB_ERROR': {code: 9001, msg: '서버 응답이 없거나 오류가 발생하였습니다.'},

    'SERVER_MAINTENANCE': {code: 9999, msg: '서버 점검중입니다.'},
};

export const LSCACHE_BASE_EXPIRE_MINUTE = 60;
export const LSCACHE_VERSION = '240328';
export const LSCACHE_KEY = {
    MENUS: 'menu',
    BRANCH_LIST: 'branch-list',
    SERVICE_APP_LIST: 'service-app-list',
    APP_AUTH_TYPE_LIST: 'app-auth-type-list',
    SEASON_INFO: 'contract-season-info',
    LOC_CODES: 'loc-codes',
};

export const CONTRACT_APP_LIST = [
    {id: 'tomonote', name: '토모노트'},
    {id: 'playdd', name: '플레이딩동'},
    {id: 'jelliing', name: '젤링'},
    {id: 'momo', name: '모모한글수'},
    {id: 'tomobooks', name: '별별책방'},
    {id: 'tomoenglish', name: '플라잉'},
];

export const CONTRACT_APP_LIST_HQ = [
    {id: 'tomonote_class', name: '클래스'},
    {id: 'tomonote_books', name: '꾸러미결합'},
    {id: 'tomonote_momo', name: '한글수결합'},
    {id: 'tomonote_bookstore', name: '별별책방결합'},
    {id: 'playdd', name: '플레이딩동'},
    {id: 'jelliing', name: '젤링'},
    {id: 'momo', name: '모모한글수'},
    {id: 'tomobooks', name: '별별책방'},
    {id: 'tomoenglish', name: '플라잉'},
];

export const CONTRACT_LIMIT = {
    QUANTITY: {
        HQ: 199,
        BRANCH: 30
    }
};
